import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { DconConfigAPI } from "src/app/features/dfte-grid-view/config/config";
import { CloudExtractLoadService } from '../cloud-extract-load.service';
import { ExtractFromLoadService } from "src/app/dcon-modules/extract-from-cloud/extract-from-load.service";
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AlertPopupComponent } from 'src/app/shared/components/alert-popup/alert-popup.component';
import { TaskListPopupComponent } from 'src/app/shared/components/task-list-popup/task-list-popup.component';


@Component({
  selector: 'app-cloud-extract-load-home',
  templateUrl: './cloud-extract-load-home.component.html',
  styleUrls: ['./cloud-extract-load-home.component.scss']
})
export class CloudExtractLoadHomeComponent implements OnInit {
  loadToCloudData: any = [];
  public loadNewBtnDisable: boolean = false;
  dataSourceCloud: any = new MatTableDataSource();
  dataSourceCloudWorkBook: any = new MatTableDataSource();
  filterSelectObj = [];
  filterSelectObjForWorkbook = [];
  filteredValue;
  filterValuesCWB = {};
  filterValues = {};
  emptyTable: boolean = false;
  public searchText;
  searchText1;
  isTrainStopUrl: boolean;
  queryParams: any;
  displayedColumns: string[] = ['check_box', 'batch_key', 'batch_status', 'instance', 'requested_date', 'action'];
  displayedCloudWorkBookColumns: string[] = ['batch_key', 'batch_status', 'instance', 'requested_date', 'action'];
  refresh: boolean = false;
  pageIndex = 0;
  size = 5;
  p: any = 1;
  p1: any = 1;
  failedToFetchBatchKeys: boolean = false;
  tableData: any;
  tableDataCloudWorkBook: any;
  cloudTaskLevelData: any = [];
  segregationArray: string[] = ['Workbook Extraction - Complete', 'Cloud Extraction - Complete'];
  selectedBatchKey: any;
  @ViewChild('scrollToMe') scrollToMe: ElementRef;

  constructor(public dialog: MatDialog, private notification: NotificationService, private celService: CloudExtractLoadService, private DataService: ExtractFromLoadService,
    private router: Router, private route: ActivatedRoute, private _data: DataService, private cd: ChangeDetectorRef) {
    this.isTrainStopUrl = this.celService.getisTrainStopUrl();
    if (this.isTrainStopUrl) {
      const obj = JSON.parse(sessionStorage.getItem('queryParams'));
      this.queryParams = obj;
    }
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'batch_status',
        options: []
      }, {
        name: 'Cloud Instance',
        columnProp: 'instance',
        options: []
      }
    ];
    this.filterSelectObjForWorkbook = [
      {
        name: 'Status',
        columnProp: 'batch_status',
        options: []
      }, {
        name: 'Cloud Instance',
        columnProp: 'instance',
        options: []
      }
    ];
  }

  ngOnInit(): void {
    // console.log("@@@", this.celService.getisTrainStopUrl(), window.location.href)
    this.celService.fileUploadedTaskList = [];
    const prjid = this._data.projectID;
    if (prjid === null || prjid === undefined) {
      window.location.href = DconConfigAPI.redirectUri;
    } else {
      this.getLoadBatchkeys();
      this.getSelectedBatchTasks();
      this.dataSourceCloud.filterPredicate = this.createFilter();
      this.dataSourceCloudWorkBook.filterPredicate = this.createFilter();
    }
  }

  paginate(event: any) {
    this.pageIndex = event;
    this.selectedBatchKey = undefined;
    this.tableData = this.dataSourceCloud.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  paginateCWB(event: any) {
    this.pageIndex = event;
    this.tableDataCloudWorkBook = this.dataSourceCloudWorkBook.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  getLoadBatchkeys() {
    this.emptyTable = false;
    this.maskPage();
    this.loadNewBtnDisable = false;
    this.celService.getLoadBatchkeys().subscribe((res) => {
      if (res?.Status === "SUCCESS") {
        this.refresh = true;
        this.failedToFetchBatchKeys = false;
        this.loadToCloudData = this.getDistinctLoadBatchKeys(res.Batch_Key);
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.dataSourceCloud.data = this.loadToCloudData.filter((elem) => this.segregationArray.includes(elem.batch_status));
        this.tableData = this.dataSourceCloud.data;
        //  this.dataSource.data = this.instanceList;
        this.dataSourceCloudWorkBook.data = this.loadToCloudData.filter((elem) => !this.segregationArray.includes(elem.batch_status));
        this.tableDataCloudWorkBook = this.dataSourceCloudWorkBook.data;

        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.dataSourceCloud.data, o.columnProp);
          o.options.splice(0, 0, "None");
        });

        this.filterSelectObjForWorkbook.filter((o) => {
          o.options = this.getFilterObject(this.dataSourceCloudWorkBook.data, o.columnProp);
          o.options.splice(0, 0, "None");
        });

        if (this._data.workbookCreated) {
          this.cd.detectChanges();
          this.scrollToMe.nativeElement.scrollIntoView({ behavior: 'smooth' });
          this._data.workbookCreated = false;
        }

        if (this.loadToCloudData.length === 0) {
          // this.alertPopUp('Info Alert','No records found');
        } else {
          res.Batch_Key.forEach((element) => {
            if (element.batch_status === 'New') { //|| element.batch_status === 'Extraction - Complete'
              this.loadNewBtnDisable = true;
            }
          });
        }
      } else {
        // this.alertPopUp('Error Alert','Not able to fetch the records');
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.failedToFetchBatchKeys = true;
      }
    }, (error) => {
      // this.alertPopUp('Error Alert',error);
      this.notification.showError('Something went wrong!');
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.failedToFetchBatchKeys = true;
    });
  }

  getDistinctLoadBatchKeys(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = curr;
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }

  onClickBatchKey(item) {
    const obj = {
      status: item.status,
      data: item
    };
    this.celService.batchKey = item.batch_key;
    this.celService.options = obj;

    if (item.batch_status === "New") {
      this.celService.getBatchKeyDetails(item.batch_key).subscribe(res => {
        this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
        this.celService.fromTable = true;
        this.celService.tabval.next('load');
        this.router.navigate(['load-to-cloud'], { relativeTo: this.route });
      }
        , err => {
          this.notification.showError('Something went wrong!');
          // alert(err.status +"---"+ err.message);
          // this.router.navigate(['cloud-extract'],{ relativeTo: this.route });
        });

    } else if (item.batch_status === "Cloud Load - In Progress") {
      // this.celService.getBatchKeyDetails(item.batch_key).subscribe(res=>{
      //   console.log("getBatchKeyDetails",res);
      //   this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
      //   this.celService.fromTable = true;
      //   this.celService.tabval.next('load');
      //   this.router.navigate(['load-to-cloud'],{ relativeTo: this.route });
      // })
      this.showPopUp(item.batch_key);
    } else if (item.batch_status === "Cloud Extraction - Complete" || item.batch_status === "Workbook Extraction - Complete") {
      // this.celService.getBatchKeyDetails(item.batch_key).subscribe(res=>{
      //   console.log("getBatchKeyDetails",res);
      //   this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
      this.celService.extractBatchKey = item.batch_key;
      this.celService.fromTable = true;
      this.celService.tabval.next('select');
      this.router.navigate(['load-to-cloud'], { relativeTo: this.route });
    } else {
      this.showInfoAlert(item.batch_key, item.batch_status);
    }
  }

  showLoadNewConfigPopUp() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "245px",
      data: {
        type: 'Cloud Load Info',
        mess: `This step will restart cloud load from the beginning, and you will not be able to use any existing extracts. <br>Would you like to proceed? `,
        cloudLoad: true
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.onLoadNewConfig();
      }
    });
  }

  onLoadNewConfig() {
    this.maskPage();
    this.celService.options = null;
    this.celService.batchKey = null;
    this.celService.fromTable = false;
    this.celService.extractBatchKey = null;
    this.celService.configType = "load";
    this.celService.tabval.next('select');
    this.router.navigate(['load-to-cloud'], { relativeTo: this.route });
  }


  prepareObjSet(batchDetails) {
    const data = [];
    batchDetails.forEach(element => {
      const obj = JSON.parse(element.config_details);
      obj['saveStatus'] = false;
      if (obj.linedetail != null && obj.linedetail.length > 0) {
        obj.linedetail.forEach(element => {
          if (element.taskselected === 'Y') {
            obj['saveStatus'] = true;
          }
        });
      }
      data.push(obj);
    });
    // console.log("getBatchKeyDetails", data);
    return data;
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }
  showPopUp(batchKey) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Task Status',
        mess: `Batch Key ${batchKey} <b>: Load To Cloud - In Progress</b>`,
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  showInfoAlert(batchKey, status) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Task Status',
        mess: `Batch Key ${batchKey} <b>: ${status}</b>`,
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  filterChange(filter, event, indexVal) {
    // if(filter.modelValue == "None"){
    //   this.filterSelectObj[indexVal].modelValue= undefined;
    // }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceCloud.filter = JSON.stringify(this.filterValues);
    // this.searchText = undefined;
    this.tableData = this.dataSourceCloud.filteredData;

  }

  filterChangeCWB(filter, event, indexVal) {
    this.pageIndex = 0;
    this.size = 5;
    this.p1 = 1;
    this.filterValuesCWB[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceCloudWorkBook.filter = JSON.stringify(this.filterValuesCWB);
    this.tableDataCloudWorkBook = this.dataSourceCloudWorkBook.filteredData;

  }

  createFilter() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
          // console.log(searchTerms);
        }
      }

      // console.log(searchTerms);

      const nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          if (data.batch_status.toLowerCase() === searchTerms.batch_status && (!searchTerms.instance || searchTerms.instance === "undefined")) {
            found = true;
          } else if (data.batch_status.toLowerCase() === searchTerms.batch_status && data.instance.toLowerCase() === searchTerms.instance) {
            found = true;
          } else if ((!searchTerms.batch_status || searchTerms.batch_status === "undefined") && data.instance.toLowerCase() === searchTerms.instance) {
            found = true;
          }
          else if ((!searchTerms.batch_status || searchTerms.batch_status === "undefined") && (!searchTerms.instance || searchTerms.instance === "undefined")) {
            found = true;
          }
          return found;
        } else {
          return true;

        }
      };
      return nameSearch();
    };
    return filterFunction;
  }

  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }

  filterResults() {
    if (!this.searchText) {
      this.dataSourceCloud = [...this.loadToCloudData];
    } else {
      this.dataSourceCloud = this.loadToCloudData.filter((item) => {
        return item.batch_key.toUpperCase().indexOf(this.searchText.toUpperCase()) > -1;
      });
    }
  }

  search(value: string): void {
    if (value == null || value === undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    const serchText = value.toUpperCase();
    this.dataSourceCloud.data = this.loadToCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText)).filter((elem) => this.segregationArray.includes(elem.batch_status));
    this.tableData = this.dataSourceCloud.filteredData;
    if (this.loadToCloudData.some(item => item.batch_key === value) || value === "") {
      // this.dataSourceCloud.filter = "";
      // this.dataSourceCloud.data = [];
      this.emptyTable = false;
      this.filterValues = {};
      this.searchText = undefined;
      this.filterSelectObj = [
        {
          name: 'Status',
          columnProp: 'batch_status',
          options: []
        }, {
          name: 'Cloud Instance',
          columnProp: 'instance',
          options: []
        }
      ];
      this.filterSelectObj.filter((o) => {
        o.options = this.getFilterObject(this.dataSourceCloud.data, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceCloud = new MatTableDataSource();
      this.dataSourceCloud.filterPredicate = this.createFilter();
      this.dataSourceCloud.data = this.loadToCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText)).filter((elem) => this.segregationArray.includes(elem.batch_status));
      this.dataSourceCloud.filter = JSON.stringify(this.filterValues);
      this.tableData = this.dataSourceCloud.filteredData;
    } else {
      this.emptyTable = true;
    }
  }

  searchForCloudWorkbook(value: string) {
    if (value == null || value === undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p1 = 1;
    const serchText = value.toUpperCase();
    this.dataSourceCloudWorkBook.data = this.loadToCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText)).filter((elem) => !this.segregationArray.includes(elem.batch_status));
    this.tableDataCloudWorkBook = this.dataSourceCloudWorkBook.filteredData;
    if (this.loadToCloudData.some(item => item.batch_key === value) || value === "") {
      this.emptyTable = false;
      this.filterValuesCWB = {};
      this.searchText1 = undefined;
      this.filterSelectObjForWorkbook = [
        {
          name: 'Status',
          columnProp: 'batch_status',
          options: []
        }, {
          name: 'Cloud Instance',
          columnProp: 'instance',
          options: []
        }
      ];
      this.filterSelectObjForWorkbook.filter((o) => {
        o.options = this.getFilterObject(this.dataSourceCloudWorkBook.data, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceCloudWorkBook = new MatTableDataSource();
      this.dataSourceCloudWorkBook.filterPredicate = this.createFilter();
      this.dataSourceCloudWorkBook.data = this.loadToCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText)).filter((elem) => !this.segregationArray.includes(elem.batch_status));
      this.dataSourceCloudWorkBook.filter = JSON.stringify(this.filterValuesCWB);
      this.tableDataCloudWorkBook = this.dataSourceCloudWorkBook.filteredData;
    } else {
      this.emptyTable = true;
    }
  }

  alertPopUp(type, mess) {
    const dialogRef = this.dialog.open(AlertPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: type,
        mess: mess
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  onRefresh() {
    this.refresh = false;
    this.emptyTable = false;
    this.selectedBatchKey = undefined;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.p1 = 1;
    // this.dataSourceCloud.filter = "";
    // this.dataSourceCloud.data = [];
    this.filterValues = {};
    // this.search('');
    this.searchText = undefined;
    this.maskPage();
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'batch_status',
        options: []
      }, {
        name: 'Cloud Instance',
        columnProp: 'instance',
        options: []
      }
    ];
    this.dataSourceCloud = new MatTableDataSource();
    this.dataSourceCloud.filterPredicate = this.createFilter();
    this.dataSourceCloudWorkBook = new MatTableDataSource();
    this.dataSourceCloudWorkBook.filterPredicate = this.createFilter();
    this.getLoadBatchkeys();
    this.getSelectedBatchTasks();
    // this.dataSourceCloud._filter = "";

  }

  specialCharRemove(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57));
  }

  downloadFiles(rowData) {
    let pathSplitArray: any;
    let body: any;
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    if (rowData.output_file_path != null) {
      pathSplitArray = rowData.output_file_path.split(rowData.batch_key);
      body = {
        "filePath": pathSplitArray[0],
        "batchKey": rowData.batch_key
      };
    } else {
      body = {
        "filePath": rowData.output_file_path,
        "batchKey": rowData.batch_key
      };
    }
    this.celService.downloadFilesFromTable(body).subscribe(res => {
      if (res.byteLength === 1176) {
        this.notification.showError("Failed to download the file");
      } else {
        this.writeContents(res, `${rowData.batch_key}_${rowData.instance}.zip`);
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }
    },
      error => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        // console.log(error.message);
        this.notification.showError("Failed to download the file");
      });
    // }else{
    //   this._data.apiCallInProgress = false;
    //   document.getElementById("overlay").style.display = "none";
    //   this.notification.showError("Failed to download the file");
    // }

  }

  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  searchOnInput(event, key) {
    if (event == null || event === undefined || event === '') {
      (key === 'cloud') ? this.search('') : this.searchForCloudWorkbook('');
    }
  }

  getSelectedBatchTasks() {
    this.maskPage();
    this.celService.getSelectedBatchTasks().subscribe((res) => {
      if (res?.Result === "SUCCESS" && res.Cloud_Load_Data !== undefined) {
        this.cloudTaskLevelData = this.getDistinctBatchKeys(res.Cloud_Load_Data);//res.Batch_key_details;
        console.log("distinct batchkey", this.cloudTaskLevelData);

        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }

    }, error => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.notification.showError('Something went wrong!');
    });
  }

  getDistinctBatchKeys(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      const item = {
        "batch_key": curr.batch_key,
        module: []
      };
      const task_list = [{ "taskName": curr.task_name, "taskStatus": curr.status, "reqType": curr.request_type }];
      const currModule = {
        "application": curr.application,
        "task_list": task_list,
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
        obj[curr.batch_key].module.push(currModule);
      } else {
        //same batch && new module
        if (!obj[curr.batch_key].module
          .find(e => e.application === curr.application)) {
          obj[curr.batch_key].module.push(currModule);
        } else {
          //same batch && same module
          obj[curr.batch_key].module.map(e => {
            if (e.application === curr.application) {
              const taskObj = { "taskName": curr.task_name, "taskStatus": curr.status, "reqType": curr.request_type };
              e.task_list.push(taskObj);
            }
          });
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }


  tasklistPopup(batchkey, element) {
    const data = JSON.parse(JSON.stringify(this.cloudTaskLevelData.filter(e => e.batch_key === batchkey)));
    const modData = this.prepareinfoData(data, element);
    const dialogRef = this.dialog.open(TaskListPopupComponent, {
      width: "795px",
      height: "470px",
      data: {
        moduleData: { batchkey: batchkey, module: modData },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

    });
  }

  prepareinfoData(obj, element) {
    const module = [];
    if (element.batch_status === 'New' || element.batch_status === 'Cloud Load - Error' || element.batch_status === 'Cloud Load - Complete' || element.batch_status === 'Cloud Load - Process Submitted' || element.batch_status === "Cloud Load - In Progress") {
      const appData = [];
      obj[0].module.forEach(ele => {
        const t = [];
        ele.task_list.forEach(e => {
          if (e.reqType === "LOAD") {
            t.push(e.taskName);
          }
        });
        const taskArray = {
          application: ele.application,
          task_list: t
        };
        appData.push(taskArray);
      });
      obj[0].module = appData;
      module.push(obj[0]);
    } else {
      const appData = [];
      obj[0].module.forEach(ele => {
        const t = [];
        ele.task_list.forEach(e => {
          t.push(e.taskName);
        });
        const taskArray = {
          application: ele.application,
          task_list: t
        };
        appData.push(taskArray);
      });
      obj[0].module = appData;
      module.push(obj[0]);
    }
    const mod = [];
    module[0].module.forEach((ele, i) => {
      if (ele.task_list.length > 0) {
        mod.push(ele);
      }
    });
    module[0].module = mod;
    return module;
  }

}
